export default __webpack_public_path__ + "0238926271247bfbeef9e60005c158dd.png";